import ApiService from '@/common/api.service';

import {
  FETCH_SEARCH
} from './actions.type';
import {
  SET_SEARCH,
} from './mutations.type';

const state = {
  search: {},
};

const getters = {
  search(state) {
    return state.search;
  },
};

const actions = {
  [FETCH_SEARCH](context, payload) {
    return new Promise((resolve, reject) => {
      const {keyword} = payload;
      const {query} = payload;
      return ApiService.get(`restaurants/search/${keyword}`, query)
          .then((response) => {
            context.commit(SET_SEARCH, response.data);
            resolve({response, payload});
          })
          .catch((error) => {
            reject(error.data);
          });
    });
  },
};

const mutations = {
  [SET_SEARCH](state, search) {
    state.search = search;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
